export const customerCallsTitle = "Customer Calls"
export const customerCallsSubtitle =
  "Calls your customers placed to you through Nuve. The lead is only captured if your team answers."
export const customerCallsHeatmapHours = ["12a", "3a", "6a", "9a", "12p", "3p", "6p", "9p"]

export const getHeatmapIntensity = (value: number, maximum: number) => (maximum ? 0.12 + (value / maximum) * 0.7 : 0.12)

export const getCallOutcomeLabel = (outcome: "answered" | "missed") =>
  outcome === "answered" ? "Answered" : "No answer"
